export const validateName = (name) => {
  return name.trim() !== ''
}

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email.trim())
}

export const validatePassword = (password) => {
  return password.length >= 6
}

export const validateProjectName = (name) => {
  return name.trim() !== ''
}

const DOMAIN_REGEX = /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/
const IPV4_SEGMENT = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)'
const IPV4_REGEX = new RegExp(`^${IPV4_SEGMENT}(?:\\.${IPV4_SEGMENT}){3}$`)
const HAS_PROTOCOL_REGEX = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//

const validateHttpUrl = (website) => {
  const value = String(website || '').trim()
  if (!value) return false

  const candidate = HAS_PROTOCOL_REGEX.test(value) ? value : `https://${value}`

  try {
    const parsed = new URL(candidate)
    if (!['http:', 'https:'].includes(parsed.protocol)) return false
    const hostname = parsed.hostname
    return DOMAIN_REGEX.test(hostname) || IPV4_REGEX.test(hostname)
  } catch {
    return false
  }
}

export const validateProjectURL = (website) => {
  return validateHttpUrl(website)
}

export const validateLoginPageURL = (website) => {
  return validateHttpUrl(website)
}
